import React, { useState, useEffect } from "react";
import { Menu, X, Sparkles } from "lucide-react";
import { navLinks } from "../mock";
import { Button } from "./ui/button";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-[#f4ebde]/95 backdrop-blur-md shadow-sm" : "bg-[#f4ebde]/80 backdrop-blur-sm"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-20">
        <a href="#" className="flex items-center gap-2">
          <Sparkles className="w-6 h-6" style={{ color: "#143527" }} strokeWidth={1.8} />
          <div className="flex flex-col leading-none">
            <span className="font-serif text-3xl" style={{ color: "#143527" }}>tidy</span>
            <span className="text-[10px] uppercase tracking-[0.18em] text-[#143527]/65 mt-0.5 hidden sm:block">
              Facility Services
            </span>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-[15px] font-medium text-[#143527] hover:text-[#e8a428] transition-colors"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Button
            className="rounded-full px-6 py-5 btn-primary text-[15px]"
            onClick={() => {
              const el = document.getElementById("quote");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
          >
            Request a Quote
          </Button>
        </div>

        <button
          className="lg:hidden text-[#143527]"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#f4ebde] border-t border-[#e6dcc7] px-6 py-6 space-y-5">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="block text-base font-medium text-[#143527]"
              onClick={() => setOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <Button className="rounded-full w-full btn-primary">Request a Quote</Button>
        </div>
      )}
    </header>
  );
}
